module.exports = __webpack_public_path__ + "img/favourites.d442df9a.svg";